var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"u-breadcrumbs"},_vm._l((_vm.mappedBreadcrumbs),function(crumb,cI){return _c('li',{key:("crumb-" + cI)},[_c(crumb.is,_vm._b({tag:"component"},'component',crumb.attrs,false),[_vm._v(_vm._s(crumb.label))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }